import { useMutation } from "@tanstack/react-query";
import L from "leaflet";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { ClipLoader } from "react-spinners";
import MarkerIcon from "../../assets/images/marker.svg";
import { useRecaptcha } from "../../Common/Hook/useRecaptcha";
import { postContact } from "../../Common/Service/api";
import BreadCrumb from '../BreadCrumb';
import FooterOne from '../Footer/FooterOne';
import { pageTitle } from '../PageTitle';
import Recaptcha from "../Recaptcha";
import Header from "../Header/HeaderOne";

const ContactUs = () => {
    pageTitle('Contact Us');

    const { recaptchaToken } = useRecaptcha()
    const officeCoordinate = [
        {
            key: "head-office",
            lat: -6.286614429427538,
            lng: 106.78080375672921,
            city: "Jakarta",
            location: "Menara Pondoh Indah"
        },
        {
            key: "branch-office",
            lat: -1.2464192939154644,
            lng: 116.92666015212565,
            city: "Balikpapan",
            location: "Borneo Paradiso"
        }
    ]

    const coordinateIcon = new L.Icon({
        iconUrl: MarkerIcon,
        iconRetinaUrl: MarkerIcon,
        popupAnchor: [0, 0],
        iconSize: [24, 24],
    })

    const initialForm = {
        name: "",
        email: "",
        subject: "",
        phone: "",
        message: ""
    }

    const subjects = [
        "Product",
        "Services",
        "Industries",
        "Others"
    ]

    const getMapZoom = () => {
        const screenWidth = window.innerWidth
        if (screenWidth < 499) return 4
        if (screenWidth < 991) return 5
        return 6
    }

    const [contactForm, setContactForm] = useState(initialForm)
    const [isLoading, setIsLoading] = useState(false);
    const [mapZoom, setMapZoom] = useState(getMapZoom())

    const postContactMutation = useMutation({
        mutationKey: ["post-contact"],
        mutationFn: (payload) => {
            setIsLoading(true)
            return postContact(payload)
        },
        onSuccess: (response) => {
            setIsLoading(false)
            onSuccessPostContact(response)
        },
        onError: (error) => {
            setIsLoading(false)
            onErrorPostContact(error)
        }
    })

    const onSuccessPostContact = (response) => {
        if (response.status === 200) {
            enqueueSnackbar({
                message: response.data.message,
                variant: "success",
            })
            setContactForm(initialForm)
        }
    }

    const onErrorPostContact = (error) => {
        console.log(error)
    }

    const onChangeContactForm = (event) => {
        const name = event.target.name
        let value = event.target.value

        if (name === "phone") {
            value = value.replace(/[^\d]/g, "")
        }
        setContactForm({
            ...contactForm,
            [name]: value
        })
    }

    const onSubmit = (event) => {
        event.preventDefault();
        if (!recaptchaToken) {
            enqueueSnackbar({
                message: "Please complete the reCAPTCHA",
                variant: "warning",
            })
        } else {
            const payload = {
                fullname: contactForm.name,
                email: contactForm.email,
                phone: contactForm.phone,
                subject: contactForm.subject,
                message: contactForm.message,
                recaptchaToken: recaptchaToken
            }
            postContactMutation.mutate(payload)
        }
    };

    useEffect(() => {
        const onResize = () => setMapZoom(getMapZoom())
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [])

    return (
        <>
            <Header />
            {/* <BreadCrumb /> */}
            <section className="contact__page p_relative see__pad">
                <div className="auto-container">
                    <div className="row">
                        {/* <div className="col-lg-4 col-md-6 col-ms-12">
                            <div className="contact__left">
                                <figure>
                                    <img src={contact} alt="" />
                                </figure>
                                <h4>Contact Information</h4>
                                <div className="contact__info">
                                    <div className="contact__block">
                                        <div className="icon">
                                            <i className="icon-19"></i>
                                        </div>
                                        <div className="contact__text">
                                            <Link to="tell:3025550107">(302) 555-0107</Link> <br />
                                            <Link to="tell:3025550107">(207) 555-0119</Link>
                                        </div>
                                    </div>
                                    <div className="contact__block">
                                        <div className="icon two">
                                            <i className="icon-20"></i>
                                        </div>
                                        <div className="contact__text">
                                            <Link to="mailto:willie.jennings@example.com">willie.jennings@example.com</Link> <br />
                                            <Link to="mailto:tranthuy.nute@gmail.com">tranthuy.nute@gmail.com</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-12">
                            <div className="contact__right">
                                <div className="form__title">
                                    <div className="title__data">
                                        <div className="sub__title">
                                            <h4>Contact Us</h4>
                                        </div>
                                        {/* <div className="title">
                                            <h2>Get a Free Quote</h2>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="form-inner">
                                    <form onSubmit={onSubmit} className="default-form">
                                        <div className="row clearfix">
                                            <div className="col-xl-6 form-group">
                                                <input value={contactForm.name} onChange={onChangeContactForm} type="name" name="name" placeholder="Your Name *" required disabled={isLoading} />
                                            </div>
                                            <div className="col-xl-6 col-lg-12 form-group">
                                                <input value={contactForm.email} onChange={onChangeContactForm} type="email" name="email" placeholder="Your Email *" required disabled={isLoading} />
                                            </div>
                                            <div className="col-xl-6 col-lg-12 form-group">
                                                {/* <input value={contactForm.subject} onChange={onChangeContactForm} type="text" name="subject" placeholder="Your Subject " /> */}
                                                <select required value={contactForm.subject} name="subject" onChange={onChangeContactForm} disabled={isLoading}>
                                                    <option value="" disabled hidden>Choose Your Subject *</option>
                                                    {subjects.map((subject) => (
                                                        <option key={subject} value={subject}>{subject}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-xl-6 col-lg-12 form-group">
                                                <input value={contactForm.phone} onChange={onChangeContactForm} type="text" name="phone" placeholder="Your Phone *" required disabled={isLoading} />
                                            </div>
                                            <div className="ccol-xl-6 col-lg-12 form-group">
                                                <textarea value={contactForm.message} onChange={onChangeContactForm} name="message" placeholder="Message *" required disabled={isLoading}></textarea>
                                            </div>
                                            <div className="col-xl-12 form-group">
                                                <Recaptcha />
                                            </div>
                                            <div className="col-xl-12 form-group message-btn btn-box">
                                                <button className="theme-btn theme-btn-one" type="submit" name="submit-form" disabled={isLoading}>
                                                    Send your Message <ClipLoader color="#ffffff" size={24} loading={isLoading} />
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px", margin: "32px" }}>
                <div className="sub__title">
                    <h4>SEE OUR OFFICE</h4>
                </div>
                <div className="texts">
                    <p style={{ textAlign: "center", letterSpacing: "2px" }}>
                        JAKARTA - BALIKPAPAN
                    </p>
                </div>
            </div>

            {/* <div className="google__map">
                <figure>
                <img src={map} alt="" />
                </figure>
                </div> */}
            {/* dekstop 6; table 5; mobile 4 */}
            <MapContainer center={[officeCoordinate[0].lat, officeCoordinate[0].lng]} zoom={mapZoom} scrollWheelZoom={false} className="office-map-wrapper">
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {officeCoordinate.map((office) => (
                    <Marker
                        key={office.key}
                        position={[office.lat, office.lng]}
                    // icon={coordinateIcon}
                    >
                        <Popup className='map-popup'>
                            <p>{office.location}, {office.city}</p>
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>

            {/* <section className="pricing__section see__pad p_relative">
                <div className="pattern-layer">
                    <div className="pattern-4 p_absolute" data-parallax='{"x": 100}' style={{ backgroundImage: `url(${shape4})` }}></div>
                </div>
                <div className="auto-container">
                    <div className="title__data">
                        <div className="sub__title">
                            <h4>Pricing</h4>
                        </div>
                        <div className="title">
                            <h2>Product Price</h2>
                        </div>
                    </div>
                    <div className="row">
                        {pricingData.map((item, id) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay={item.delay} data-wow-duration="1500ms" key={id}>
                                <div className="price__content p_relative">
                                    <div className="price__data">
                                        <h5>{item.price_name}</h5>
                                        <h4><span>$</span>{item.amount} / <span>{item.time}</span></h4>
                                    </div>
                                    <div className="price__block">
                                        <div className="price__list">
                                            <ul>
                                                <li>{item.list_a}</li>
                                                <li>{item.list_b}</li>
                                                <li>{item.list_c} </li>
                                                <li>{item.list_d}</li>
                                                <li>{item.list_e}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="price__icon">
                                        <i className="icon-16"></i>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}
            <FooterOne />
        </>
    );
};

export default ContactUs;
